<template>
  <div class="slider_main">
    <template v-if="images.length > 0">
      <div
        v-for="i in [currentIndex]"
        :key="i"
        class="header-detail bg-dark"
        :style="{ 'background-image': 'url(' + currentImg.image_url + ')' }"
      ></div>

      <a class="slider_prev" v-if="images.length > 1" @click="prev" href="#">
        <img src="@/assets/icon/left.svg" width="40" alt=""
      /></a>
      <a class="slider_next" v-if="images.length > 1" @click="next" href="#">
        <img src="@/assets/icon/right.svg" width="40" alt="" />
      </a>
    </template>

    <template v-else>
      <div
        class="header-detail bg-dark"
        :style="{
          'background-image':
            'url(' + require('@/assets/placeholder.svg') + ')',
        }"
      ></div>
    </template>

    <div class="mask-content-title">
      <h1 class="mask-content-title-brand">
        {{ title }}
      </h1>
    </div>
  </div>
</template>

 <style lang="css" scoped>
.slider_main {
  position: relative;
  margin: 0px auto;
  margin-left: -15px;
  margin-right: -15px;
  margin-top: -35px;
  top: 0px;
  left: 0px;
  overflow: hidden;
  visibility: visible;
}
.slider_next {
  width: 55px;
  height: 55px;
  z-index: 1;
  display: block;
  position: absolute;
  top: 190px;
  right: 0;
}
.slider_prev {
  width: 55px;
  height: 55px;
  z-index: 1;
  display: block;
  position: absolute;
  top: 190px;
  left: 0;
}
@media only screen and (max-width: 991.5px) {
  .slider_next,
  .slider_prev {
    top: 120px !important;
  }
}
</style>
<script >
export default {
  name: "baseSlider",
  props: {
    title: {
      type: String,
      default: null,
    },
    images: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      //   images: [
      //     "https://cdn.pixabay.com/photo/2015/12/12/15/24/amsterdam-1089646_1280.jpg",
      //     "https://cdn.pixabay.com/photo/2016/02/17/23/03/usa-1206240_1280.jpg",
      //     "https://cdn.pixabay.com/photo/2015/05/15/14/27/eiffel-tower-768501_1280.jpg",
      //     "https://cdn.pixabay.com/photo/2016/12/04/19/30/berlin-cathedral-1882397_1280.jpg",
      //   ],
      timer: null,
      currentIndex: 0,
    };
  },
  mounted: function () {
    this.startSlide();
  },

  methods: {
    startSlide: function () {
      this.timer = setInterval(this.next, 15000);
    },

    next: function () {
      this.currentIndex += 1;
    },
    prev: function () {
      this.currentIndex -= 1;
    },
  },

  computed: {
    currentImg: function () {
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    },
  },
};
</script>